import { useEffect, useRef } from "react";
import { io } from "socket.io-client";

const BASE = process.env.REACT_APP_BASE_URL || "http://localhost:3008";

/**
 * Connect to the Socket.IO server with a JWT and register event handlers.
 * handlers: { "lead:new": fn, "request:update": fn, ... }
 * `watchRequestId` auto-joins that request's live-status room.
 */
export function useSocket(token, handlers = {}, watchRequestId = null) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;
  const socketRef = useRef(null);

  useEffect(() => {
    if (!token) return;
    const socket = io(BASE, { auth: { token }, transports: ["websocket", "polling"] });
    socketRef.current = socket;

    socket.onAny((event, payload) => handlersRef.current[event]?.(payload));
    if (watchRequestId) {
      const join = () => socket.emit("watch:request", watchRequestId);
      socket.on("connect", join);
      if (socket.connected) join();
    }
    return () => socket.disconnect();
  }, [token, watchRequestId]);

  return socketRef;
}
